import React   from 'react'
import { InputGroup, Button, Popover, MenuItem, Menu, Icon } from "@blueprintjs/core";
import { Translate ,I18n} from "react-redux-i18n";

export  function ChannelSelector({ selected, onLangClick }) {
  const languages = {
    email: {   label: "Email", short_label: "Email" },
    sms: {   label: "SMS", short_label: "SMS" }
  };
  const languageMenu = (
    <Menu>
      <MenuItem
        className="item-en"
        onClick={() => onLangClick("email")}
        text="Email"
      />
      <MenuItem
        className="item-sv"
        onClick={() => onLangClick("sms")}
        text="SMS"
      />
    </Menu>
  );
  return (
    <Popover content={languageMenu} position="bottom-left">
      <div className="channel-selector">
        <span className="lang-name">
          {languages[selected].short_label}
        </span>
        <Icon icon="chevron-down" className="icon" />
      </div>
    </Popover>
  );
}

class FriendForm extends React.Component{
    state={
        type:'email'
    }

    select=(type, id)=>{
        this.setState({type: type});
        this.props.changeChanelType(type, id)
    }
    
    render(){  
       const {form_errors, updateFields, removeFriend, id} = this.props;
        let errors={
            email:null,
            sms:null
        }
        if(form_errors){
            if(form_errors[0][id]){
                if('email' in form_errors[0][id]){
                    errors.email = form_errors[0][id].email;
                }
                if('sms' in form_errors[0][id]){
                    errors.sms = form_errors[0][id].sms;
                }            
            }
        }  
    return (
        <>
        <div className="invite-friends-form">
            <ChannelSelector selected={this.state.type}  onLangClick={type=>this.select(type, id)} className="channel-selector" />
            {this.state.type === 'email' && 
                <div
                    className={
                        errors.email
                        ? "form-group error"
                        : "form-group"
                    }
                >
                    {errors.email && (
                        <label htmlFor="email">
                            <Translate
                                value={errors.email[0]}
                            />
                        </label>
                    )}
                    <InputGroup
                        type="email"
                        className="no-icon"
                        placeholder={I18n.t("sign_up.placeholders.email_address")}
                        fill={true}
                        id="email"
                        intent={errors.email ? "danger" : ""}
                        onChange={(e)=>updateFields(e, id)}
                    />
                </div>
            }
            {this.state.type === 'sms' && 
                    <div
                        className={
                            errors.sms
                            ? "form-group error"
                            : "form-group"
                        }>
                        {errors.sms && (
                            <label htmlFor="sms">
                                <Translate
                                    value={errors.sms[0]}
                                />
                            </label>
                        )}
                        <InputGroup
                            type="tel"
                            className="no-icon"
                            pattern="[+0-9]*"
                            placeholder={I18n.t("b2b.phone")}
                            fill={true}
                            id="sms"
                            intent={errors.sms ? "danger" : ""}
                            onChange={(e)=>updateFields(e, id)}
                        />
                </div>  
                }

            <Button onClick={_=>removeFriend(id)} className="remove-friend-line">
                <Icon icon="remove" className="icon" />
            </Button>
        </div>
    </>
    )
    }
}

export default FriendForm;